import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { PageContainer, PageContentView } from "components/shared";
import Classes, { ContactInfo } from "model";
import PhoneNumberWidget from "./components/PhoneNumberWidget";
import "./styles.css";
import "./mobile.css";


/**
 * @function PhoneNumberWithCodePage
 * @return {React.Component}
 * @exported true
 * @description The main component for PhoneNumberWithCodePage
 */
export default function PhoneNumberWithCodePage(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { user } = useModel();
    const { phone } = user;
    const homePhoneContactInfo = ContactInfo.initByID(phone)

    // Sets the values for the data and ui variables
    const data = { ...getDefaultPageData(homePhoneContactInfo), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
    // The state to be passed to the state manager
    const state = { data, ui };

    // :: React.state, React.setState -> OBJECT
    // Function to initalize the controller for the state manager
    const controller = (state, setState) => ({
        data: state.data, // Set the data property of the controller
        ui: state.ui, // Set the ui property of the controller

      onChange: type => val => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", type], val)
        .submit(setState);
      }
    });

  return (
    <PageContainer className="phone-number-with-code-page" state={ state } controller={ controller }>
      <PageContent />
    </PageContainer>
  )
}

/**
 * @name getDefaultPageData
 * @returns {Void}
 * @description Returns the page data.
 */
export const getDefaultPageData = (homePhoneContactInfo) => {
    return {
        homePhone: {
          codeID: "united-states",
          phoneNumber: homePhoneContactInfo ? homePhoneContactInfo.value.replace(/-| |\(|\)/gi, "") : ""
        },
        mobilePhone: {
          codeID: "united-states",
          phoneNumber: ""
        },
        workPhone: {
          codeID: "united-states",
          phoneNumber: ""
        }
    }
};

/**
 * @name getDefaultPageUI
 * @param {Void}
 * @return {OBJECT}
 * @description Returns the page ui.
 */
export const getDefaultPageUI = () => {
    return {
        homePhoneCodeSelect: {
          isActive: false
        },
        mobilePhoneCodeSelect: {
          isActive: false
        },
        workPhoneCodeSelect: {
          isActive: false
        }
    }
};

function PageContent(props) {
  return (
    <PageContentView>
        <div className="flex-container flex-vertical flex-width">
            <PhoneNumberWidget />
        </div>
      </PageContentView>
  );
}